export class PostGetLocationDetailsRequest {
    locationID?: string;
    cityOrZip?: string;
    latitude?: number;
    longitude?: number;
}